import { Sparkles } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEARCH_MODES } from '../../constants/searchModes';
import './SearchModeToggle.css';
import { ICON_SIZE, Toggle } from '../../design-system';

/**
 * AI is the enabled state; keyword filtering is the disabled state. The Sparkles mark
 * keeps the compact control legible without repeating both mode labels in the
 * already constrained composer row.
 */
export function SearchModeToggle({ mode, onModeChange }) {
  const { t } = useTranslation('reader');
  const isAISearch = mode === SEARCH_MODES.AI;
  const currentModeLabel = isAISearch
    ? t('ragChat.modes.ai')
    : t('ragChat.modes.keyword');

  return (
    <div
      className="search-mode-toggle"
      data-mode={isAISearch ? 'ai' : 'keyword'}
    >
      <Sparkles size={ICON_SIZE.xs} aria-hidden="true" />
      <Toggle
        className="search-mode-switch"
        checked={isAISearch}
        onCheckedChange={(checked) => onModeChange(
          checked ? SEARCH_MODES.AI : SEARCH_MODES.KEYWORD
        )}
        label={t('ragChat.title')}
        title={`${t('ragChat.modes.label')}: ${currentModeLabel}`}
      />
    </div>
  );
}

export default SearchModeToggle;
